"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getCookie = (name) => {
    const regexp = new RegExp(`(?:^${name}|; *${name})=(.*?)(?:;|$)`, 'gi');
    const result = regexp.exec(document.cookie);
    return result === null ? null : result[1];
};
const getBcId = () => getCookie('BrowserCookieId');
const makeAnalyticsInterceptor = ({ allowedUrls, appVersion }) => (request) => {
    var _a, _b;
    if (!allowedUrls.some(url => { var _a; return (_a = request.url) === null || _a === void 0 ? void 0 : _a.includes(url); })) {
        return request;
    }
    const platform = (_a = getCookie('X-CVNA-Platform')) !== null && _a !== void 0 ? _a : 'Web';
    const appVersionHeader = platform === 'Web' ? appVersion : getCookie('X-CVNA-AppVersion');
    const bcid = getBcId();
    /* eslint-disable-next-line camelcase */
    const formFactor = (_b = window.WURFL) === null || _b === void 0 ? void 0 : _b.form_factor;
    const deviceType = platform === 'Web' ? formFactor : getCookie('X-CVNA-DeviceType');
    request.headers['X-CVNA-Platform'] = platform;
    request.headers['X-CVNA-AppVersion'] = appVersionHeader;
    request.headers['X-CVNA-DeviceType'] = deviceType;
    if (platform === 'Web') {
        request.headers['X-CVNA-BrowserCookieId'] = bcid;
    }
    else {
        request.headers['X-CVNA-DeviceId'] = getCookie('X-CVNA-DeviceId');
    }
    return request;
};
exports.default = makeAnalyticsInterceptor;
